import { GoogleMap, InfoWindow, Marker, useJsApiLoader } from '@react-google-maps/api';
import moment from 'moment';
import React, { useState } from 'react';
import './MapStyles.css';

const ModalOpenMap = ({ isOpen, onClose, centerPositions, fusoUser, selectedPosition, positions, lastPosisitionData }) => {

    const { isLoaded } = useJsApiLoader({
        id: 'google-map-script',
        googleMapsApiKey: "AIzaSyChY0qKEv0A5uZX5eoibw0aSZbbs3zxfnM"
    })

    const [showPerc, setShowPerc] = useState(false)

    return (
        isOpen && (
            <div className="modal-overlay">
                {isLoaded ? (
                    <GoogleMap
                        mapContainerStyle={{ width: "95%", height: "95%" }}
                        center={{
                            lat: centerPositions.lat,
                            lng: centerPositions.lng,
                        }}
                        zoom={centerPositions.zoom}
                    >
                        {positions && positions}
                        {selectedPosition && (
                            <InfoWindow
                                position={{
                                    lat: selectedPosition.latitude,
                                    lng: selectedPosition.longitude,
                                }}
                            >
                                <div>
                                    <h3>{selectedPosition.plate}</h3>
                                    <h5 style={{ fontStyle: "oblique" }}>
                                        {selectedPosition.description}
                                    </h5>
                                    <p>{`Ignição: ${selectedPosition.ignition === 0 ? 'Desligada': 'Ligada' }`}</p>
                                    <p>{`Velocidade: ${selectedPosition.speed.toFixed(2)} Km/h`}</p>
                                    <p>{`Hodometro: ${(selectedPosition.odometerGps/1000).toFixed(2)}Km`}</p>
                                    <p>{`Dia: ${moment(selectedPosition.dateTime)
                                        .subtract(Math.abs(fusoUser), "hours")
                                        .format("DD/MM/yyyy")} Hora: ${moment(selectedPosition.dateTime)
                                            .subtract(Math.abs(fusoUser), "hours")
                                            .format("HH:mm:ss")}`}</p>
                                </div>
                            </InfoWindow>
                        )}

                        {lastPosisitionData && showPerc && lastPosisitionData}

                    </GoogleMap>
                ) : (
                    <p>Carregando mapa...</p>
                )}

                <button
                    onClick={() => onClose()} // Função para fechar o mapa
                    style={{
                        position: 'absolute',
                        top: '4%',
                        right: '7%',
                        padding: '8px',
                        backgroundColor: '#ff4c4c',
                        color: 'white',
                        border: 'none',
                        borderRadius: '5px',
                        cursor: 'pointer',
                    }}
                >
                    Fechar
                </button>
            </div>
        )
    );
};

export default ModalOpenMap;
